var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{staticClass:"cus-tree-render",attrs:{"data":_vm.tree,"render-content":_vm.renderContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }